import {useCallback} from 'react';

import {LegendBox} from '../../../../../../layout/chart/legend-box/legend-box';
import {LegendWrapper} from '../../../../../../layout/chart/legend-wrapper/legend-wrapper';
import {useLocale} from '../../../../../../provider/locale/locale-hook';
import {Locale} from '../../../../../../provider/locale/localization';
import {
    ActionDynamicsEnum,
    OnlinePresenceActionDynamicsType,
} from '../../../../../../service/online-presence/online-presence-type';
import {getEnumValue} from '../../../../../../util/enum';
import {noop} from '../../../../../../util/function';
import {targetActionsColorMap, targetActionsLangKeyMap} from '../../target-actions-dynamics-helper';

type PropsType = {
    data: OnlinePresenceActionDynamicsType;
    isCompareMode: boolean;
    legendFilter: Array<ActionDynamicsEnum>;
    setLegendFilter: (value: Array<ActionDynamicsEnum>) => void;
    isCompareLegendActive: boolean;
    setIsCompareLegendActive: (value: boolean) => void;
    staticChart?: boolean;
    allowedKeys: Array<ActionDynamicsEnum>;
};

export function TargetActionsLegend(props: PropsType): JSX.Element {
    const {
        isCompareMode,
        data,
        legendFilter,
        setLegendFilter,
        isCompareLegendActive,
        setIsCompareLegendActive,
        staticChart,
        allowedKeys,
    } = props;

    const {getLocalizedString} = useLocale();

    const onItemChange = useCallback(
        (value: ActionDynamicsEnum) => {
            if (legendFilter.includes(value)) {
                setLegendFilter(legendFilter.filter((legendItem: ActionDynamicsEnum): boolean => legendItem !== value));
            } else {
                setLegendFilter([...legendFilter, value]);
            }
        },
        [legendFilter, setLegendFilter]
    );

    return (
        <LegendWrapper>
            {data.bar.current.map(({label: actionName}) => {
                const actionKey = getEnumValue(ActionDynamicsEnum, actionName);

                if (!actionKey || !allowedKeys.includes(actionKey)) {
                    return null;
                }

                return (
                    <LegendBox
                        checked={legendFilter.includes(actionKey)}
                        color={targetActionsColorMap[actionKey]}
                        key={actionName}
                        label={<Locale stringKey={targetActionsLangKeyMap[actionKey]} />}
                        onChange={staticChart ? noop : () => onItemChange(actionKey)}
                    />
                );
            })}

            {isCompareMode && (
                <LegendBox
                    checked={isCompareLegendActive}
                    label={getLocalizedString('ONLINE_PRESENCE_ANALYTICS__RANGE_PICKER_LABEL__COMPARE')}
                    onChange={staticChart ? noop : () => setIsCompareLegendActive(!isCompareLegendActive)}
                    stripes
                />
            )}
        </LegendWrapper>
    );
}
